module.exports = __webpack_public_path__ + "static/media/bg-3.cfbd2137.jpg";